import { render, staticRenderFns } from "./L02Style.vue?vue&type=template&id=50b8ef9e&"
import script from "./L02Style.vue?vue&type=script&lang=js&"
export * from "./L02Style.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports